import TemplateView from "../../../TemplateView"
import $ from "jquery"
import _ from "underscore"
import {isOlVersion, UserManagementConstants} from "../../../constants"
import {
    OnlineAccountFieldsCreateUserPopupDrawer,
    OnlineAccountFieldsEditUserPopupDrawer
} from "../../../administration/userManagement/OnlineAccountFieldsUserPopupDrawer"
import {
    DownloadableAccountFieldsCreateUserPopupDrawer,
    DownloadableAccountFieldsEditUserPopupDrawer
} from "../../../administration/userManagement/DownloadableAccountFieldsUserPopupDrawer"
import EditAccountInformationSection from '../../../administration/userManagement/EditAccountInformationSection'
import CreateAccountInformationSection from "../../../administration/userManagement/CreateAccountInformationSection"
import {MODE} from "../UserPanelContainer"
import * as StringUtils from "../../../util/StringUtils"
import {ValidationErrors} from '../constants'
import messageResource from '../../../messageResource'
import {getInstance as getModalAlert} from '../UserPanelModalAlert'
import {ModalAlertPointerPosition} from '../../../components/modalAlert/constants'
import {filterSet} from '../../../atUtils'
import PasswordPolicyManager from '../../../util/passwords/PasswordPolicyManager'

export default class AccountInformation extends TemplateView {
    constructor({
        id = "",
        mode = null,
        userGroupRow = null,
        timeZoneGroupRow = null,
        restoreState = () => {},
        scrollTo = () => {},
    }) {
        super();
        this.id = id;
        this.updateOnInit = false;
        this.isOnline = isOlVersion
        this.mode = mode

        this.userGroupRow = userGroupRow
        this.timeZoneGroupRow = timeZoneGroupRow
        this.restoreState = restoreState
        this.scrollTo = scrollTo

        this.state = {
            firstName: null,
            lastName: null,
            middleInitial: null,
            email: "",
            username: null,
            hireDate: (new Date()).toJSON(),
            releaseDate: null,
            password: null,
            retypedPassword: null,
            enabled: false,
            enabledInOtherProduct: false,
            editUserIsLoggedIn: false,
            firstTTDate: null,
            firstRequestDate: null,
            userManagementData: {
                viewerSettings: {
                    enabledFeatures: {},
                },
                allUserGroups: null,
                allTimeZoneGroups: null
            },
            currentTime: (new Date()).toJSON(),
            activated: false,
            userId: null,
            providerErrors: {},
            passwordValidationResult: null,
            hasLeavesOrTTBeforeNewHireDateError: false,

            baseAccountInformationReadOnly: false,
            accessToActiTimeEditable: true,
            accessToActiPlansEditable: true,
            hireAndReleaseDatesEditable: false,

            loaded: false,
        }

        this.onAnyStatePropertyChanged(['firstName', 'lastName', 'middleInitial', 'email', 'enabled', 'enabledInOtherProduct', 'activated'], () => {
            this.accountFieldsDrawer.updateAccountSettings(this.state)
        })

        this.onStatePropertyChanged('firstName', (name) => {
            this.editAccountInformation.setValue( this.editAccountInformation.firstNameField, name );
        })

        this.onStatePropertyChanged('lastName', (name) => {
            this.editAccountInformation.setValue(this.editAccountInformation.lastNameField, name);
        })

        this.onStatePropertyChanged('middleInitial', (name) => {
            this.editAccountInformation.setValue(this.editAccountInformation.middleNameField, name);
        })

        this.onStatePropertyChanged('email', (email) => {
            this.editAccountInformation.setValue(this.editAccountInformation.emailField, email);
        })

        this.onStatePropertyChanged('username', (username) => {
            if (this.accountFieldsDrawer.userNameDrawer)
                this.accountFieldsDrawer.userNameDrawer.setValue(this.accountFieldsDrawer.userNameDrawer.usernameField, username);
        })

        this.onStatePropertyChanged('hireDate', (hireDate) => {
            this.editAccountInformation.setHireDate(_.isString(hireDate) ? Date.parseJSONDate(hireDate): hireDate);
        })

        this.onStatePropertyChanged('hasLeavesOrTTBeforeNewHireDateError', (hasLeavesOrTTBeforeNewHireDateError) => {
            this.editAccountInformation.toggleHireDateChangedWrning(hasLeavesOrTTBeforeNewHireDateError)
        })

        this.onAnyStatePropertyChanged(['releaseDate', 'hireAndReleaseDatesEditable'], ({releaseDate, hireAndReleaseDatesEditable}) => {
            this.editAccountInformation.setReleaseDate(releaseDate, hireAndReleaseDatesEditable)
            //hide read-only release date row in edit user panel if there is no release date
            if (this.editAccountInformation.initAndShowReleaseDate)
                this.editAccountInformation.setReleaseDate(this.state.releaseDate, hireAndReleaseDatesEditable);
            this.find(".releaseDateData").toggle((hireAndReleaseDatesEditable || !!releaseDate) && this.mode === MODE.EDIT)
        })

        this.onStatePropertyChanged('password', (password) => {
            if (this.accountFieldsDrawer.passwordDrawer)
                this.accountFieldsDrawer.passwordDrawer.setValue(this.accountFieldsDrawer.passwordDrawer.passwordField, password)
        })

        this.onStatePropertyChanged('retypedPassword', (password) => {
            if (this.accountFieldsDrawer.passwordDrawer)
                this.accountFieldsDrawer.passwordDrawer.setValue(this.accountFieldsDrawer.passwordDrawer.passwordCopyField, password)
        })

        this.onStatePropertyChanged('enabled', (enabled) => {
            this.editAccountInformation.accessSelector.setState({enabled});
        })

        this.onStatePropertyChanged('enabledInOtherProduct', (enabledInOtherProduct) => {
            this.editAccountInformation.setState({enabledInOtherProduct})
        })

        this.onStatePropertyChanged('firstTTDate', (firstTTDate) => {
            this.editAccountInformation.firstTTDate = firstTTDate;
        })

        this.onStatePropertyChanged('firstRequestDate', (firstRequestDate) => {
            this.editAccountInformation.firstLeaveRequestDate = firstRequestDate;
        })

        this.onAnyStatePropertyChanged(['userManagementData', 'hireAndReleaseDatesEditable'], ({userManagementData, hireAndReleaseDatesEditable}) => {
            this.editAccountInformation.corporateSchedule = userManagementData.defaultWorkSchedule;
            this.editAccountInformation.updateHireDateSelector(userManagementData, this.state.hireDate, hireAndReleaseDatesEditable);
            if (this.editAccountInformation.initAndShowReleaseDate)
                this.editAccountInformation.initAndShowReleaseDate(this.state.releaseDate, userManagementData, hireAndReleaseDatesEditable);
        })

        const initFields = () => {
            const self = this;
            this.accountFieldsDrawer.initFields({
                accountSettings: this.state,
                currentTime: this.state.currentTime,
                editedUserIsSelf: this.state.editUserIsLoggedIn
            });
            if (this.accountFieldsDrawer.userNameDrawer) {
                this.accountFieldsDrawer.userNameDrawer.usernameField.on('changed',
                        (e, username, duplicateError) => {
                            if (self.state.username !== username) {
                                self.setStateInternal({username});
                                self.trigger('changeUsername', [username, duplicateError]);
                            }
                        });
            }

            if (this.accountFieldsDrawer.passwordDrawer) {
                this.accountFieldsDrawer.passwordDrawer.setPasswordsAreMandatory(true);
                this.accountFieldsDrawer.passwordDrawer.passwordField.on('changed',
                        (e, password, retypedPassword, isPasswordChanged, isPasswordCopyChanged) => {
                            self.setStateInternal({password, retypedPassword})
                            self.trigger('changePassword', [password, retypedPassword, isPasswordChanged, isPasswordCopyChanged]);
                        }
                )
            }
        }

        this.onStatePropertyChanged('editUserIsLoggedIn', (editSelf) => {
            this.editAccountInformation.setState({editSelf})
            initFields();
        })

        this.onStatePropertyChanged('activated', () => initFields())
        this.onStatePropertyChanged('currentTime', () => initFields())
        this.onStatePropertyChanged('userId', (userId) => this.editAccountInformation.userId = userId)

        this.onAnyStatePropertyChanged(['providerErrors', 'passwordValidationResult'], ({passwordValidationResult, providerErrors}) => {
            this._updateErrors(providerErrors, passwordValidationResult)
        })

        this.onStatePropertyChanged('baseAccountInformationReadOnly', readOnly => {
            this.editAccountInformation.setDisabled(readOnly)
            if (this.accountFieldsDrawer.userNameDrawer)
                this.accountFieldsDrawer.userNameDrawer.setFieldDisabled(this.accountFieldsDrawer.userNameDrawer.usernameField, readOnly)
            this.find('.passwordBlock').toggle(this.mode === MODE.EDIT && !readOnly)

            if (!isOlVersion) {
                this.find('.passwordColumn').toggle(!readOnly)
                this.find('.passwordCopyColumn').toggle(!readOnly)
            }
        })

        this.onStatePropertyChanged('accessToActiPlansEditable', accessToActiPlansEditable => {
            this.editAccountInformation.setState({accessToOtherProductEditable: accessToActiPlansEditable})
        })

        this.onStatePropertyChanged('accessToActiTimeEditable', accessToActiTimeEditable => {
            if (this.editAccountInformation.accessSelector !== null) {
                this.editAccountInformation.accessSelector.setState({readOnly: !accessToActiTimeEditable})
            }
        })

        this.onStatePropertyChanged('loaded', loaded => {
            this.editAccountInformation.setLoaded(loaded)
        })
    }

    templateHtml() {
        let _html =
            "<div class='sectionHeader'><%=account_information_header%></div>" +
            "<div id='<%=id%>_accountInformationSection'><div class='sectionContent'>" +
            "    <div class='inputFieldsContainer'>" +
            "            <div class='userInputField firstName'>" +
            "                <div class='inputGroup'>" +
            "                   <div class='firstNameInputContainer'>" +
            "                       <input tabindex='10' type='text' class='firstNameField inputFieldWithPlaceholder' name='firstName' id='<%=id%>_firstNameField' " +
            "                           placeholder='<%=first_name_placeholder%>' maxlength='32' autocomplete='off'>" +
            "                   </div><!-- this comment is needed to remove space between inputs-->" +
            "                   <div class='miInputContainer'>" +
            "                       <input tabindex='11' type='text' class='middleNameField inputFieldWithPlaceholder' name='middleName' id='<%=id%>_middleNameField'" +
            "                              placeholder='<%=mi_placeholder%>' maxlength='32' autocomplete='off'>" +
            "                   </div>" +
            "                </div>" +
            "                <div id='<%=id%>_firstNameEmptyError' class='inlineErrorMessage'><%=cannot_be_empty%></div>" +
            "            </div>" +
            "            <div class='userInputField lastName'>" +
            "                <input tabindex='12' type='text' class='lastNameField inputFieldWithPlaceholder' name='lastName' id='<%=id%>_lastNameField' " +
            "                       placeholder='<%=last_name_placeholder%>' maxlength='32' autocomplete='off'>" +
            "                <div id='<%=id%>_lastNameEmptyError' class='inlineErrorMessage'><%=cannot_be_empty%></div>" +
            "            </div>" +
            "            <% if (isOnline) { %>" +
            "            <div class='userInputField usernameContainer username' id='<%=id%>_usernameColumn'>" +
            "                <input tabindex='13' type='text' class='usernameField inputFieldWithPlaceholder' name='username' id='<%=id%>_usernameField' " +
            "                       placeholder='<%=username_placeholder%>' maxlength='191' autocomplete='off'>" +
            "                <div id='<%=id%>_usernameEmptyError' class='usernameEmptyError inlineErrorMessage'><%=cannot_be_empty%></div>" +
            "                <div id='<%=id%>_duplicateUsernameError' class='duplicateUsernameError inlineErrorMessage'><%=username_duplicate%></div>" +
            "            </div>" +
            "           <% } %>" +
            "            <div class='userInputField email'>" +
            "                <input tabindex='14' type='text' class='emailField inputFieldWithPlaceholder' name='email' id='<%=id%>_emailField' " +
            "                       placeholder='<%=email_placeholder%>' maxlength='255' autocomplete='off'>" +
            "                <div id='<%=id%>_emailEmptyError' class='emailEmptyError inlineErrorMessage'><%=cannot_be_empty%></div>" +
            "                <div id='<%=id%>_emailInvalidError' class='emailInvalidError inlineErrorMessage'><%=email_invalid%></div>" +
            "            </div>" +
            "    </div>"

        _html +=
            "    <%if ( !isOnline ){  %>" +
            "    <div class='downloadableRow'>" +
            "       <div class='details'>" +
            "          <span  id='<%=id%>_passwordRequirementsTip' class='passwordHintLink'></span>" +
            "          <%=downloadable_row_details%>" +
            "       </div>" +
            "       <div class='inputFieldsContainer'>" +
            "           <div style='display:none;' class='userInputField usernameColumn username' id='<%=id%>_usernameColumn'>" +
            "             <input tabindex='14' type='text' class='usernameField inputFieldWithPlaceholder' name='username'"+
            "                    id='<%=id%>_usernameField' placeholder='<%=username_placeholder%>'" +
            "                    maxlength='191' autocomplete='off'>" +
            "               <div id='<%=id%>_usernameEmptyError' class='usernameEmptyError inlineErrorMessage'>" +
            "                  <%=username_empty%>" +
            "               </div>" +
            "               <div id='<%=id%>_duplicateUsernameError' class='duplicateUsernameError inlineErrorMessage'>" +
            "                  <%=username_duplicate%>" +
            "               </div>" +
            "           </div>" +
            "           <div class='userInputField passwordColumn'>" +
            "             <input tabindex='15' type='password' class='passwordField inputFieldWithPlaceholder'" +
            "                    name='password' id='<%=id%>_passwordField' maxlength='255' autocomplete='off'>" +
            "               <div id='<%=id%>_passwordEmptyError' class='passwordEmptyError inlineErrorMessage'>" +
            "                  <%=password_empty%>" +
            "               </div>" +
            "               <div class='passwordsErrorContainer' id='<%=id%>_errorsContainer'></div>" +
            "           </div>" +
            "           <div class='userInputField passwordCopyColumn'>" +
            "             <input tabindex='16' type='password' class='passwordCopyField inputFieldWithPlaceholder'"+
            "                    name='passwordCopy' id='<%=id%>_passwordCopyField' maxlength='255' autocomplete='off'>" +
            "               <div id='<%=id%>_passwordCopyEmptyError' class='passwordCopyEmptyError inlineErrorMessage'>" +
            "                 <%=password_copy_empty%>" +
            "               </div>" +
            "               <div id='<%=id%>_passwordsDoNotMatchError' class='passwordsDoNotMatchError inlineErrorMessage'>" +
            "                 <%=passwords_mismatch%>" +
            "               </div>" +
            "           </div>" +
            "         </div>" +
            "       </div>" +
            "    </div>" +
            "    <% } %>" +
            "    <div class='passwordBlock'>" +
            "            <div class='resetPassword' style='display: none' id='<%=id%>_resetPasswordLink'><%=reset_password%></div>" +
            "            <div class='resendInvitation' style='display: none' id='<%=id%>_resendInvitation'><%=resend_invitation%></div>" +
            "    </div>"

        _html +=
            "    <div class='userDataTable'>" +
            "       <div id='<%=id%>_accessBoxRow' class='accessDataContainer'>" +
            "           <div id='<%=id%>_accessToOtherProductSelectorLabel' class='createData labelCell accessSelectorLabel actiplans accessToOnlyOtherProductSelectorLabel'>" +
            "               <%=access_title%>" +
            "           </div>" +
            "           <div id='<%=id%>_accessToProductSelectorLabel' class='editData labelCell accessSelectorLabel accessToProductSelectorLabel'>" +
            "               <%=access_to%>:" +
            "           </div> " +
            "           <div class='editData valueCell accessSelectorLabel actitimeSelectorLabel'>" +
            "               <%=product_actitime%>" +
            "           </div>" +
            "           <div id='<%=id%>_accessSelectorPlaceholder' class='editData valueCell accessSelectorCell accessSelectorPlaceholder'></div>" +
            "           <div class='editData accessSelectorSeparator'></div>" +
            "           <div class='editData valueCell accessSelectorLabel accessToOtherProductSelectorLabel'>" +
            "               <%=product_actiplans%>" +
            "           </div>" +
            "           <div id='<%=id%>_accessToOtherProductSelectorPlaceholder' class='createData editData valueCell accessSelectorCell accessToOtherProductSelectorPlaceholder'></div>" +
            "       </div>" +
            "        <div class='userGroupPlaceholder'/>" +
            "        <div class='timeZoneGroupPlaceholder'/>" +
            "        <div id='<%=id%>_hireDate' class='hireDateData'>" +
            "            <div class='labelCell selectorsLabelCell'>" +
            "                <%=hire_date_title%>" +
            "            </div>" +
            "            <div class='hireDateLabel'></div>" +
            "            <div class='valueCell hireDateValueCell'>" +
            "                <div id='<%=id%>_hireDatePlaceholder' class='atNextMount'></div>" +
            "            </div>" +
            "        </div>" +
            "        <div id='<%=id%>_hireDateEmptyError' class='inlineErrorMessage forDateFields'><%=hire_date_empty%></div>" +
            "            <div id='<%=id%>_hireDateInFutureForSelfError' class='inlineErrorMessage forDateFields'><%=future_hire_date%></div>" +
            "        <div id='<%=id%>_releaseDate' class='releaseDateData'>" +
            "            <div class='labelCell selectorsLabelCell'>" +
            "                <%=release_date_title%>" +
            "            </div>" +
            "            <div class='releaseDateLabel'></div>" +
            "            <div class='valueCell hireDateValueCell'>" +
            "                <div id='<%=id%>_releaseDatePlaceholder' class='atNextMount'></div>" +
            "            </div>" +
            "                <div class='deleteDateBtn'><a id='<%=id%>_delReleaseDateBtn' class='valueCell'>&nbsp;</a></div>" +
            "            </div>" +
            "    </div>" +
            "</div>";
        return _html;
    }

    messageKeys() {
        return {
            first_name_placeholder: "user.first_name",
            mi_placeholder: "user.mi",
            last_name_placeholder: "user.last_name",
            username_placeholder: "user.username",
            email_placeholder: "user.email_short",
            cannot_be_empty: 'user.add_edit.error.cannot_be_empty',
            first_name_empty: 'user.add_edit.error.first_name_empty',
            last_name_empty: 'user.add_edit.error.last_name_empty',
            username_empty: 'user.add_edit.error.username_empty',
            username_duplicate: 'user.add_edit.error.username_duplicate',
            email_empty: 'user.add_edit.error.email_empty',
            email_invalid: 'user.add_edit.error.email_invalid',
            hire_date_title: 'userlist.userdata.account_section.hire_date',
            hire_date_empty: 'user.add_edit.js.error.hire_date_empty',
            future_hire_date: 'user.add_edit.js.error.hire_date_in_future_for_self',
            release_date_title: 'userlist.userdata.account_section.release_date',
            access_title: 'userlist.userdata.account_section.access',
            access_to: 'user.add_edit.access_to',
            product_actiplans: 'product.actiplans',
            product_actitime: 'product.actitime',
            account_information_header: 'userlist.userdata.account_section.header',
            reset_password: 'user.edit.reset_password',
            resend_invitation: 'user.edit.resend_invitation',
            downloadable_row_details: 'user.add_edit.login_details',
            password_empty: 'user.add_edit.error.password_empty',
            password_copy_empty: 'user.add_edit.error.password_copy_empty',
            passwords_mismatch:'user.add_edit.error.passwords_do_not_match'

        }
    }


    afterRender() {
        const accountFieldsDrawer = (this.mode === MODE.EDIT) ?
                                    (isOlVersion ? new OnlineAccountFieldsEditUserPopupDrawer() : new DownloadableAccountFieldsEditUserPopupDrawer()) :
                                    (isOlVersion ? new OnlineAccountFieldsCreateUserPopupDrawer() : new DownloadableAccountFieldsCreateUserPopupDrawer());
        this.editAccountInformation = this.mode === MODE.EDIT ? new EditAccountInformationSection() : new CreateAccountInformationSection()
        this.accountFieldsDrawer = accountFieldsDrawer;
        const el = document.getElementById(this.id);
        this.editAccountInformation.init({
            lightBoxEl: el,
            userManagementData: this.state.userManagementData,
            currentTime: this.state.currentTime,
            userId: this.state.userId,
            accountSettings: this.state,
            corporateSchedule: this.state.userManagementData.defaultWorkSchedule,
            userGroupsEnabled: this.state.userManagementData.viewerSettings.enabledFeatures.hasOwnProperty(UserManagementConstants.UGRFeature),
            timeZoneGroupsEnabled: this.state.userManagementData.viewerSettings.enabledFeatures.hasOwnProperty(UserManagementConstants.TZGFeature),
            firstTTDate: this.state.firstTTDate,
            firstLeaveRequestDate: this.state.firstRequestDate,
            editedUserIsSelf: this.state.editUserIsLoggedIn,
            specificVersionDrawerConstructor: accountFieldsDrawer,
            scrollableContainerEl: $(el).find(".innerContent"),
            showGroupRows: false,
            needValidation: this.mode !== MODE.EDIT,
            disableDuplicateUsernameCheck: this.mode === MODE.EDIT,
            disableEmptyUsernameCheck: this.mode === MODE.EDIT,
            releaseDateLabelEl: this.find('.releaseDateLabel'),
            hireDateLabelEl: this.find('.hireDateLabel')
        })

        this.userGroupRow.init(this.find(".userGroupPlaceholder"))
        this.timeZoneGroupRow.init(this.find(".timeZoneGroupPlaceholder"))

        this.editAccountInformation.setErrorState(this.state.providerErrors, this.state.passwordValidationResult);
        const self = this;
        this.editAccountInformation.firstNameField.on('changed',
                (e, name) => {
                    if (self.state.firstName !== name) {
                        self.setState({firstName: name})
                        self.trigger('changeFirstName', [name]);
                    }
                });

        this.editAccountInformation.lastNameField.on('changed',
                (e, name) => {
                    if (self.state.lastName !== name) {
                        self.setState({lastName: name})
                        self.trigger('changeLastName', [name]);
                    }
                });

        this.editAccountInformation.middleNameField.on('changed',
                (e, name) => {
                    if ((StringUtils.isNotEmptyString(self.state.middleInitial) || StringUtils.isNotEmptyString(name)) && self.state.middleInitial !== name) {
                        self.setState({middleInitial: name})
                        self.trigger('changeMiddleName', [name]);
                    }
                });

        this.editAccountInformation.emailField.on('changed',
                (e, email) => {
                    if (self.state.providerErrors[ValidationErrors.EMAIL_WAS_EMPTY] && email.length === 0) {
                        this._showAlert(ValidationErrors.EMAIL_WAS_EMPTY)
                    } else if (self.state.email !== email) {
                        self.setState({email})
                        self.trigger('changeEmail', [email]);
                    }
                });

        $(this.editAccountInformation).on('hireDateChanged',
                (e, hireDate) => {
                    const dateStr = (hireDate) ? hireDate.toJSON() : null;
                    if (self.state.hireDate !== dateStr) {
                        self.trigger('changeHireDate', [dateStr]);
                    }
                });

        $(this.editAccountInformation).on('hireDateForceChanged',
            (e, hireDate) => {
                const dateStr = (hireDate) ? hireDate.toJSON() : null;
                if (self.state.hireDate !== dateStr) {
                    self.trigger('forceChangeHireDate', [dateStr]);
                }
            });

        $(this.editAccountInformation).on('setHasLeavesOrTTBeforeNewHireDateError', (e, hasLeavesOrTTBeforeNewHireDateError) => {
            self.trigger('setHasLeavesOrTTBeforeNewHireDateError', [hasLeavesOrTTBeforeNewHireDateError])
        })

        $(this.editAccountInformation).on('releaseDateChanged',
                (e, releaseDate) => {
                    const dateStr = (releaseDate) ? releaseDate.toJSON() : null;
                    if (self.state.releaseDate !== dateStr) {
                        self.setStateInternal({releaseDate: dateStr});
                        self.trigger('changeReleaseDate', [dateStr]);
                    }
                });

        $(this.editAccountInformation).on('changeAccess', (e, enabled) => {
            if (self.state.enabled !== enabled) {
                self.trigger('changeAccess', [enabled]);
            }
        })

        $(this.editAccountInformation).on('changeAccessToOtherProduct', (e, enabled) => {
            if (self.state.enabledInOtherProduct !== enabled) {
                self.trigger('changeAccessToOtherProduct', [enabled]);
            }
        })


        this.subscribeSelectors();

        this.initValidation()
    }

    update() {

    }

    initValidation() {
        const $firstName = this.find('.inputFieldsContainer .firstName .firstNameInputContainer')
        const $lastName = this.find('.inputFieldsContainer .lastName')
        const $email = this.find('.inputFieldsContainer .email')
        const $username = this.find('.inputFieldsContainer .username')
        const $releaseDate = this.find('.userDataTable #editUserPanel_releaseDatePlaceholder')

        this.validationFields = {
            [ValidationErrors.FIRST_NAME_EMPTY]: $firstName,
            [ValidationErrors.LAST_NAME_EMPTY]: $lastName,
            [ValidationErrors.USERNAME_EMPTY]: $username,
            [ValidationErrors.USERNAME_DUPLICATE]: $username,
            [ValidationErrors.EMAIL_EMPTY]: $email,
            [ValidationErrors.EMAIL_WAS_EMPTY]: $email,
            [ValidationErrors.EMAIL_INVALID]: $email,
            [ValidationErrors.RELEASE_DATE_IS_BEFORE_HIRE_DATE]: $releaseDate,
            [ValidationErrors.RELEASE_DATE_WAS_BEFORE_HIRE_DATE]: $releaseDate,
        }

        const emailEmptyState = {
            text: messageResource.getMessage('user.panel.edit.modal_error.email.empty') + '\n' +
                  messageResource.getMessage('user.panel.edit.modal_error.discarded'),
            pointerPosition: ModalAlertPointerPosition.RIGHT,
            offsets: {
                left: 100,
                top: 20,
            },
        }

        this.validationState = {
            [ValidationErrors.FIRST_NAME_EMPTY]: {
                text: messageResource.getMessage('user.panel.edit.modal_error.first_name.empty') + '\n' +
                      messageResource.getMessage('user.panel.edit.modal_error.discarded'),
                pointerPosition: ModalAlertPointerPosition.LEFT,
            },
            [ValidationErrors.LAST_NAME_EMPTY]: {
                text: messageResource.getMessage('user.panel.edit.modal_error.last_name.empty') + '\n' +
                      messageResource.getMessage('user.panel.edit.modal_error.discarded'),
            },
            [ValidationErrors.USERNAME_EMPTY]: {
                text: messageResource.getMessage('user.panel.edit.modal_error.username.empty') + '\n' +
                      messageResource.getMessage('user.panel.edit.modal_error.discarded'),
                pointerPosition: this.isOnline ? ModalAlertPointerPosition.RIGHT : ModalAlertPointerPosition.LEFT,
            },
            [ValidationErrors.RELEASE_DATE_IS_BEFORE_HIRE_DATE]: {
                text: messageResource.getMessage('user.add_edit.release_date_before_hire_date') + '\n' +
                      messageResource.getMessage('user.panel.edit.modal_error.discarded'),
                pointerPosition: ModalAlertPointerPosition.CENTER,
            },
            [ValidationErrors.RELEASE_DATE_WAS_BEFORE_HIRE_DATE]: {
                text: messageResource.getMessage('user.add_edit.release_date_before_hire_date'),
                pointerPosition: ModalAlertPointerPosition.CENTER,
            },
            [ValidationErrors.EMAIL_EMPTY]: emailEmptyState,
            [ValidationErrors.EMAIL_WAS_EMPTY]: {
                ...emailEmptyState,
                text: messageResource.getMessage('user.panel.edit.modal_error.email.was_empty')
            },
            [ValidationErrors.EMAIL_INVALID]: {
                text: messageResource.getMessage('user.panel.edit.modal_error.email.invalid') + '\n' +
                      messageResource.getMessage('user.panel.edit.modal_error.discarded'),
                pointerPosition: ModalAlertPointerPosition.RIGHT,
                offsets: {
                    left: 100,
                    top: 20,
                },
            },
            [ValidationErrors.USERNAME_DUPLICATE]: {
                text: messageResource.getMessage('user.panel.edit.modal_error.username.duplicate'),
                pointerPosition: this.isOnline ? ModalAlertPointerPosition.RIGHT : ModalAlertPointerPosition.LEFT,
            },
        }

        if (!this.isOnline) {
            let $password = this.find('.inputFieldsContainer .passwordColumn')
            let $passwordCopy = this.find('.inputFieldsContainer .passwordCopyColumn')
            this.validationFields = {
                ...this.validationFields,
                [ValidationErrors.PASSWORDS_DO_NOT_MATCH]: $passwordCopy,
                [ValidationErrors.PASSWORD_COPY_EMPTY]: $passwordCopy,
                [ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED]: $password
            }

            this.validationState = {
                ...this.validationState,
                [ValidationErrors.PASSWORD_COPY_EMPTY]: {
                    text: messageResource.getMessage('user.panel.edit.modal_error.password.not_match'), //seems like we need to show same error when copy is empty
                    pointerPosition: ModalAlertPointerPosition.RIGHT,
                },
                [ValidationErrors.PASSWORDS_DO_NOT_MATCH]: {
                    text: messageResource.getMessage('user.panel.edit.modal_error.password.not_match'),
                    pointerPosition: ModalAlertPointerPosition.RIGHT,
                },
                [ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED]: () => ({
                    text: PasswordPolicyManager.getErrorMessage(this.state.passwordValidationResult),
                    pointerPosition: ModalAlertPointerPosition.LEFT,
                })

            }
        }
    }

    subscribeSelectors() {
    }

    _skipPasswordCopyErrorsIfFocused(errors) {
        if (this.accountFieldsDrawer.passwordDrawer && this.accountFieldsDrawer.passwordDrawer.passwordCopyField[0].inFocus) {
            return _.omit(errors, [ValidationErrors.PASSWORDS_DO_NOT_MATCH,
                                   ValidationErrors.PASSWORD_COPY_EMPTY]);
        }
        return errors;
    }

    _updateErrors(errors, passwordValidationResult) {
        if (this.mode === MODE.CREATE) {
            this.editAccountInformation.setErrorState(errors, passwordValidationResult)
        } else {
            getModalAlert().hide()
            errors = this._skipPasswordCopyErrorsIfFocused(errors);
            const errorsServer = filterSet(errors, error => !this.validationFields[error])
            const errorsModals = filterSet(errors, error => !!this.validationFields[error])

            Object.values(this.validationFields).forEach($field => $field.removeClass('invalid').removeAttr('title'))

            Object.keys(this.validationFields)
                  .filter(error => !!errors[error])
                  .forEach(error => {
                      this.validationFields[error].addClass('invalid')
                  })

            //todo: what for?
            if (errors[ValidationErrors.PASSWORDS_DO_NOT_MATCH]) {
                this.validationFields[ValidationErrors.PASSWORDS_DO_NOT_MATCH]
                    .addClass('invalid')
                    .attr('title', messageResource.getMessage('user.panel.edit.modal_error.password.not_match'))
            }

            Object.keys(errorsModals).forEach((error) => {
                if (errors[error]) {
                    this._showAlert(error)
                }
            })
            this.editAccountInformation.setErrorState(errorsServer, passwordValidationResult)
        }
    }

    _showAlert(error) {
        let state = this.validationState[error]
        if (_.isFunction(state)) state = state();
        const $field = this.validationFields[error]
        this.scrollTo($field)

        const alert = getModalAlert().setState(state)

        alert.showAt($field, () => {
            if (error !== ValidationErrors.USERNAME_DUPLICATE
                && error !== ValidationErrors.EMAIL_WAS_EMPTY
                && error !== ValidationErrors.RELEASE_DATE_WAS_BEFORE_HIRE_DATE
                && !isPasswordError(error)) {
                this.restoreState()
            }

            const input = $field.find('input')[0]
            if (input && !isPasswordError(error)) {
                //delay focus to prevent mousedown event triggering after it
                _.defer(() => input.focus())
            }
        })
    }
}

function isPasswordError(error) {
    return [ValidationErrors.PASSWORDS_DO_NOT_MATCH,
            ValidationErrors.PASSWORD_COPY_EMPTY,
            ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED].includes(error);
}



// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/AccountInformation.js